<div class="container mb-3">
<h2 mat-dialog-title>Événements pour le {{ data.date | date: 'short' }}</h2>

<div mat-dialog-content *ngIf="data.events.length > 0; else noEvents">
  <p class="mb-0">Un évenement google agenda à été trouvé sur l'ancien créneau du R1 {{ data.date | date: 'short' }} que vous venez de changer</p>
  <p>Souhaitez vous le remplacer par un nouveau R1 le {{ data.newDate | date: 'short' }} ?</p>
  <mat-list>
    <mat-list-item *ngFor="let event of data.events">
      <strong>{{ event.summary }}</strong> <br />
      {{ event.start.dateTime | date: 'shortTime' }} - {{ event.end.dateTime | date: 'shortTime' }} <br />
      {{ event.location }}
    </mat-list-item>
  </mat-list>
</div>

<ng-template #noEvents>
  <p>Aucun événement trouvé.</p>
</ng-template>

<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="close()" class="mr-3">Fermer</button>
  <button class="event-btn" mat-raised-button *ngIf="data.events.length === 0" (click)="onCreateNewEvent(true,false)">
    Créer un événement
  </button>
  <button class="event-btn" mat-raised-button *ngIf="data.events.length > 0" (click)="onCreateNewEvent(false,true)">Remplacer l'évenement</button>
</div>
</div>